import { inject, Injectable } from '@angular/core';
import { SettingsService } from '@services/settings.service';
import { Store } from '@services/store';
import { map, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SettingsStore extends Store<any> {
  private readonly service = inject(SettingsService);

  protected getDataSource(key: string): Observable<any> {
    const [subject, attribute] = key.split('#');
    if (attribute?.length) {
      return this.service.get(subject, attribute);
    }
    return this.service.getList(subject);
  }

  getSettings<TSetting>(subject: string, attribute?: string): Observable<TSetting | undefined> {
    return this.get(`${subject}#${attribute ?? ''}`);
  }

  getDemoPharmacies(): Observable<string[]> {
    return this.get('query-workbench#demo-pharmacies').pipe(map(result => result?.demoNcpdps ?? []));
  }
}
